import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/home/index.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    meta: {
      key: '/'
    },
    component: Home
  },
  {
    path: '/products',
    name: 'Products',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "products" */ '../views/products/index.vue')
  },
  {
    path: '/products/industryCloud',
    name: 'Navigator',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "industryCloud" */ '../views/products/industry-cloud/index.vue')
  },
  {
    path: '/products/cloudPlatform',
    name: 'Navigator',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "cloudPlatform" */ '../views/products/cloud-platform/index.vue')
  },
  {
    path: '/products/navigator',
    name: 'Navigator',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "navigator" */ '../views/products/navigator/index.vue')
  },
  {
    path: '/products/pdm',
    name: 'Pdm',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "pdm" */ '../views/products/pdm/index.vue')
  },
  {
    path: '/products/mpm',
    name: 'Mpm',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "mpm" */ '../views/products/mpm/index.vue')
  },
  {
    path: '/products/ppm',
    name: 'Ppm',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "ppm" */ '../views/products/ppm/index.vue')
  },
  {
    path: '/products/npi',
    name: 'Npi',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "npi" */ '../views/products/npi/index.vue')
  },
  {
    path: '/products/pqm',
    name: 'Pqm',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "pqm" */ '../views/products/pqm/index.vue')
  },
  {
    path: '/products/pqm',
    name: 'Pqm',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "pqm" */ '../views/products/pqm/index.vue')
  },
  {
    path: '/products/deviceMate',
    name: 'DeviceMate',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "device-mate" */ '../views/products/device-mate/index.vue')
  },
  {
    path: '/products/productionLine',
    name: 'ProductionLine',
    meta: {
      key: '/products'
    },
    component: () => import(/* webpackChunkName: "production-line" */ '../views/products/production-line/index.vue')
  },
  {
    path: '/solutions',
    name: 'Solutions',
    meta: {
      key: '/solutions'
    },
    component: () => import(/* webpackChunkName: "solutions" */ '../views/solutions/index.vue')
  },
  {
    path: '/technology',
    name: 'Technology',
    meta: {
      key: '/technology'
    },
    component: () => import(/* webpackChunkName: "technology" */ '../views/technology/index.vue')
  },
  {
    path: '/technology/cloudNative',
    name: 'CloudNative',
    meta: {
      key: '/technology'
    },
    component: () => import(/* webpackChunkName: "cloud-native" */ '../views/technology/cloud-native/index.vue')
  },
  {
    path: '/technology/thread',
    name: 'Thread',
    meta: {
      key: '/technology'
    },
    component: () => import(/* webpackChunkName: "thread" */ '../views/technology/digital-thread/index.vue')
  },
  {
    path: '/technology/smartApps',
    name: 'SmartApps',
    meta: {
      key: '/technology'
    },
    component: () => import(/* webpackChunkName: "smart-apps" */ '../views/technology/smart-apps/index.vue')
  },
  {
    path: '/technology/edgeComputing',
    name: 'Edge',
    meta: {
      key: '/technology'
    },
    component: () => import(/* webpackChunkName: "edge-computing" */ '../views/technology/edge-computing/index.vue')
  },
  {
    path: '/technology/twin',
    name: 'Twin',
    meta: {
      key: '/technology'
    },
    component: () => import(/* webpackChunkName: "twin" */ '../views/technology/twin/index.vue')
  },
  {
    path: '/technology/analytics',
    name: 'Analytics',
    meta: {
      key: '/technology'
    },
    component: () => import(/* webpackChunkName: "analytics" */ '../views/technology/analytics/index.vue')
  },
  {
    path: '/technology/iot',
    name: 'Iot',
    meta: {
      key: '/technology'
    },
    component: () => import(/* webpackChunkName: "iot" */ '../views/technology/iot/index.vue')
  },
  {
    path: '/company',
    name: 'company',
    meta: {
      key: '/company'
    },
    component: () => import(/* webpackChunkName: "company" */ '../views/company/index.vue')
  },
  {
    path: '/company/careers',
    name: 'careers',
    meta: {
      key: '/company'
    },
    component: () => import(/* webpackChunkName: "careers" */ '../views/company/careers/index.vue')
  },
  {
    path: '/company/history',
    name: 'history',
    meta: {
      key: '/company'
    },
    component: () => import(/* webpackChunkName: "history" */ '../views/company/history/index.vue')
  },
  {
    path: '/company/why',
    name: 'why',
    meta: {
      key: '/company'
    },
    component: () => import(/* webpackChunkName: "why" */ '../views/company/why/index.vue')
  },
  {
    path: '/company/contact',
    name: 'contact',
    meta: {
      key: '/company'
    },
    component: () => import(/* webpackChunkName: "contact" */ '../views/company/contact-us/index.vue')
  },
  {
    path: '/trybuy',
    name: 'trybuy',
    meta: {
      key: '/trybuy'
    },
    component: () => import(/* webpackChunkName: "trybuy" */ '../views/try-buy/index.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

export default router
